var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"select",staticClass:"select__wrapper",class:{
    'select__wrapper--block': _vm.block,
    'select__wrapper--disabled': _vm.disabled,
    'select__wrapper--error': _vm.error,
    'select__wrapper--small': _vm.small,
    'select__wrapper--full-width': _vm.fullWidth,
    'select__wrapper--rounded': _vm.rounded,
    'select__wrapper--bottom-border': _vm.bottomBorder
  },on:{"click":_setup.onWindowChange}},[_c('div',{staticClass:"select",class:{
      'select--small': _vm.small
    },on:{"click":function($event){return _setup.dropDown()}}},[(_setup.selected === undefined)?_c('p',{staticClass:"select__placeholder",class:{
        'select__placeholder--small': _vm.small
      }},[_vm._v("\n      "+_vm._s(_vm.placeholder)+"\n    ")]):_c('p',{staticClass:"select__value",class:{
        'select__value--small': _vm.small
      }},[_vm._v("\n      "+_vm._s(_setup.selected.content)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"select__dropdown"})]),_vm._v(" "),(_vm.options.length > 0)?_c(_setup.BMenu,{directives:[{name:"show",rawName:"v-show",value:(_setup.dropdown),expression:"dropdown"},{name:"closable",rawName:"v-closable",value:({
      exclude: ['select'],
      handler: 'onClose'
    }),expression:"{\n      exclude: ['select'],\n      handler: 'onClose'\n    }"}],ref:"menu",attrs:{"items":_setup.items,"width":_setup.width,"match-content-width":_vm.matchContentWidth},on:{"selectedItem":_setup.selectOption}}):_vm._e(),_vm._v(" "),(_vm.infoText)?_c('p',{staticClass:"select__info-text"},[_vm._v("\n    "+_vm._s(_vm.infoText)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }